module.exports = __webpack_public_path__ + "static/media/section1.1fec0ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/component/home/section1.jpg
// module id = 512
// module chunks = 3